import store from '@/state/store'

export const fields = {
  computed: {
    fields() {
      return [
        {
          label: this.$t('costManagement.fields.costDocumentNumber'),
          key: 'number',
          isSortable: true,
          isRedirectable: true,
          tdAttr: {
            style: 'left:49.5px;position:sticky;min-width:180px;max-width:180px',
          },
          thAttr: {
            style: 'left:49.5px;position:sticky;min-width:180px;max-width:180px;z-index:1;',
          },
        },
        {
          label: this.$t('costManagement.fields.status'),
          key: 'status.name',
          isSortable: true,
          tdAttr: {
            style: 'left:229.5px;position:sticky;',
          },
          thAttr: {
            style: 'left:229.5px;position:sticky;z-index:1;',
          },
        },
        {
          label: this.$t('costManagement.fields.costType'),
          key: 'reference_type',
          isSortable: true,
        },
        {
          label: this.$t('costManagement.fields.fleetTaskNumber'),
          key: 'fleet_task.number',
          isSortable: true,
          hide: () =>
            !store.getters['identity/hasAccessAll']([
              'tms:read',
              'tms:create',
              'tms:update',
              'tms:delete',
            ]),
        },
        {
          label: this.$t('costManagement.fields.licensePlate'),
          key: 'vehicle.license_plate',
          isSortable: true,
        },
        { label: this.$t('costManagement.fields.transactionDate'), key: 'date', isSortable: true },
        {
          label: this.$t('costManagement.fields.createdDate'),
          key: 'created_on',
          isSortable: true,
        },
        { label: this.$t('costManagement.fields.cost'), key: 'total_amount', isSortable: true },
        {
          label: this.$t('costManagement.fields.accurateDownloadedDate'),
          key: 'latest_exported_on',
          isSortable: true,
        },
      ]
    },
  },
}
